/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/CustomField/Enum/Type.php */
export const type = {
	text: 'text',
} as const

/** @see backend/nexus/modules/CustomField/Enum/Type.php */
export type Type = (typeof type)[keyof typeof type]
